export default "/WebApp/dist/assets/svg/sal_link.svg";